import { WorkspaceNewService } from './../../../services/workspace-new.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { Constants } from '@utils/constants';
import { CustomWorkspaceItemInterface } from '@dto/custom-workspace-item-interface.dto';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';

@Component({
  selector: 'app-worksheet-context-menu',
  templateUrl: './worksheet-context-menu.component.html'
})
export class WorksheetContextMenuComponent extends AbstractItem implements OnInit {
  assetSymbol: string;
  listCustomWorkspaceDto: Array<CustomWorkspaceItemInterface> = [];
  componentsListAfterUpdate: Array<WorkspaceItemContentDto>;
  toolList = [
    {
      id: Constants.WINDOW_NAME_ASSET_SUMMARY,
      title: Constants.TITLE_CARD_ASSET_SUMMARY,
      type: Constants.WINDOW_NAME_ASSET_SUMMARY
    },
    {
      id: Constants.WINDOW_NAME_BOOK,
      title: Constants.TITLE_CARD_BOOK,
      type: Constants.WINDOW_NAME_BOOK
    },
    {
      id: Constants.WINDOW_NAME_VOLUME_AT_PRICE,
      title: Constants.TITLE_CARD_VOLUME_AT_PRICE,
      type: Constants.WINDOW_NAME_VOLUME_AT_PRICE
    },
    {
      id: Constants.WINDOW_NAME_QUOTE_CHART,
      title: Constants.TITLE_CARD_QUOTE_CHART,
      type: Constants.WINDOW_NAME_QUOTE_CHART
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<WorksheetContextMenuComponent>,
    private notificationService: NotificationsService,
    workspaceService: WorkspaceNewService,
    itemService: AbstractItemService,
    dialog: MatDialog
  ) {
    super(workspaceService, dialog, itemService);
    this.workspaceService = workspaceService;
  }

  @HostListener('contextmenu', ['$event'])
  onTriggerContextMenu(event) {
    event.preventDefault(); // prevent browser contextMenu opening
  }

  ngOnInit() {
  }

  openNewTool(item) {
    // if (this.validateOnlyOneAssetAssigned(this.assetSymbol.toString(), item.type, + this.workspaceService.getWksSelectedId())) {
    //   this.notificationService.error('Erro', Constants.WORKSPACE_MSG014);
    // } else {
    // }
    this.addItemWorkspace(item);

  }

  addItemWorkspace(item) {
    if (item) {
      this.workspaceService.addItemWorkspace(item, this.assetSymbol);
    } else {
      this.notificationService.error('', 'Não foi possível adicionar a ferramenta no workspace atual');
      return;
    }
  }

}
